import { create } from 'zustand';

type MessageType = 'alert' | 'confirm' | 'login';

type MessageState = {
  isVisible: boolean;
  title?: string;
  message: string;
  type: MessageType;
  onConfirm?: () => void;
  onCancel?: () => void;
  showMessage: (params: {
    title?: string;
    message: string;
    type?: MessageType;
    onConfirm?: () => void;
    onCancel?: () => void;
  }) => void;
  hideMessage: () => void;
};

export const useMessageStore = create<MessageState>((set) => ({
  isVisible: false,
  title: undefined,
  message: '',
  type: 'alert',
  onConfirm: undefined,
  onCancel: undefined,
  showMessage: ({ title, message, type = 'alert', onConfirm, onCancel }) =>
    set({
      isVisible: true,
      title,
      message,
      type,
      onConfirm,
      onCancel,
    }),
  hideMessage: () =>
    set({
      isVisible: false,
      title: undefined,
      message: '',
      type: 'alert',
      onConfirm: undefined,
      onCancel: undefined,
    }),
}));
